import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "all", "list" ]

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasAllTarget || !this.hasListTarget) return

    this.listTarget.toggleAttribute("disabled", this.allTarget.checked)
  }
}
